<template>
  <div class="contact-container">
    <div class="content-box">
      <h2>联系我们</h2>
      <div class="contact-card">
        <div class="qr-code">
          <img src="../assets/img/juhuiying.webp" alt="微信公众号二维码"/>
          <p>扫码关注微信公众号</p>
        </div>
        <div class="phone-info">
          <i class="el-icon-phone-outline"></i>
          <p class="phone-title">客服服务热线</p>
          <div class="phone-numbers">
            <p class="phone-number">赵经理：400-819-8310</p>
            <p class="phone-number">孙经理：18911604832</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs'
}
</script>

<style scoped>
/* 使用 Flex 布局实现页面垂直、水平居中 */
.contact-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  min-height: calc(100vh - 64px); /* 减去顶部导航栏高度 */
  width: 100%;
  box-sizing: border-box;
}

.content-box {
  width: 100%;
  max-width: 800px;
  text-align: center;
}

.content-box h2 {
  font-size: 28px;
  color: #1f2937;
  margin-bottom: 24px;
}

.contact-card {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 40px;
  background: #f8f9fa;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.qr-code img {
  width: 180px;
  height: 180px;
  border-radius: 8px;
  object-fit: cover;
}

.qr-code p {
  margin-top: 10px;
  color: #606266;
  font-size: 14px;
}

.phone-numbers {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.phone-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.phone-info i {
  font-size: 48px;
  color: #409EFF;
  margin-bottom: 10px;
}

.phone-title {
  font-size: 16px;
  color: #909399;
  margin-bottom: 8px;
}

.phone-number {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
}

/* ============ 移动端适配 ============ */
@media (max-width: 767px) {
  .contact-container {
    min-height: calc(100vh - 56px); /* 移动端导航高度 56px */
    padding: 24px 16px;
    box-sizing: border-box;
  }

  .content-box h2 {
    font-size: 24px;
    margin-bottom: 20px;
  }
}

@media (max-width: 560px) {
  .contact-card {
    flex-direction: column;
    gap: 28px;
    padding: 30px 18px;
  }

  .qr-code img {
    width: 150px;
    height: 150px;
  }

  .phone-info i {
    font-size: 40px;
  }

  .phone-number {
    font-size: 24px;
  }
}
</style>